module.exports = __webpack_public_path__ + "img/mary-pro.26a4bca1.jpg";